import React from "react";
import { usePagination, DOTS } from "./UsePagination";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  if (currentPage === 0 || paginationRange?.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange?.length - 1];

  return (
    <nav 
      className={`pagination-container flex items-center justify-center gap-1.5 ${className || ""}`}
      aria-label="Pagination"
    >
      {/* Previous Page Button */}
      <button 
        onClick={onPrevious} 
        disabled={currentPage === 1}
        type="button"
        className="flex items-center justify-center w-9 h-9 rounded-xl border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-900 disabled:opacity-40 disabled:hover:bg-white disabled:hover:text-slate-600 transition-all cursor-pointer disabled:cursor-not-allowed shadow-3xs active:scale-95"
      >
        <ChevronLeft className="w-4 h-4" />
      </button>

      {/* Pages List */}
      <ul className="flex items-center gap-1.5 list-none p-0 m-0">
        {paginationRange?.map((pageNumber, index) => {
          if (pageNumber === DOTS) {
            return (
              <li 
                key={`dots-${index}`} 
                className="pagination-item dots flex items-center justify-center w-9 h-9 text-slate-400 text-sm font-bold select-none"
              >
                &#8230;
              </li>
            );
          }

          const isActive = currentPage === pageNumber;

          return (
            <li key={pageNumber}>
              <button
                onClick={() => onPageChange(pageNumber)}
                type="button"
                className={`paginationNumbers-number flex items-center justify-center w-9 h-9 rounded-xl text-xs font-black transition-all cursor-pointer shadow-3xs active:scale-95 border ${
                  isActive
                    ? "active bg-[#264b82] border-[#264b82] text-white hover:bg-[#1d3d6e]"
                    : "bg-white border-slate-200 text-slate-600 hover:bg-slate-50 hover:text-slate-950"
                }`}
              >
                {pageNumber}
              </button>
            </li>
          );
        })}
      </ul>

      {/* Next Page Button */}
      <button 
        onClick={onNext} 
        disabled={currentPage === lastPage}
        type="button"
        className="flex items-center justify-center w-9 h-9 rounded-xl border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-900 disabled:opacity-40 disabled:hover:bg-white disabled:hover:text-slate-600 transition-all cursor-pointer disabled:cursor-not-allowed shadow-3xs active:scale-95"
      >
        <ChevronRight className="w-4 h-4" />
      </button>
    </nav>
  );
};

export default Pagination;
